<template>
    <footer id="Footer" class="app-footer">
        <div class="copyright">{{ localizer.get("App.Common.CopyRight") }}</div>
        <div class="policy">
            <a :href="routes.UrlPrivacyPolicy" target="_blank" class="button" :aria-label="'Beghelli.it - ' + localizer.get('App.Terms.PrivacyPolicy')">{{ localizer.get("App.Terms.PrivacyPolicy") }}</a>
            <a :href="routes.UrlCookiePolicy" target="_blank" class="button" :aria-label="'Beghelli.it - ' + localizer.get('App.Terms.CookiePolicy')">{{ localizer.get("App.Terms.CookiePolicy") }}</a>
        </div>
    </footer>
</template>

<script setup lang="ts">
import Localizer from "@Scripts/Common/Localizer";

const localizer = Localizer;
const routes = (window as any).App.routes;
</script>
